module.exports = __webpack_public_path__ + "static/water_meets_the_sky-5ed603246ab0b5d9f10442722968ef7c.jpg";